export const iconFontAwesomeMedicalHealthEye = (
	<i className="fa-solid fa-eye"></i>
);
